import request from "@/CommonDP/utils/request";

export default {
  splitRuleAdd(data) {
    return request.post('/splitRule/add', data);
  },
  splitRuleUpdate(data) {
    return request.post('/splitRule/update', data);
  },
  splitRuleDelete(id) {
    return request
      .get(`/splitRule/delete?id=${id}`)
      .then((res) => res);
  },
  splitRuleGetList(enterpriseId) {
    return request
      .get(`/splitRule/getList?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  getListByRuleId(ruleId) {
    return request
      .get(`/splitRule/layer/getListByRuleId?ruleId=${ruleId}`)
      .then((res) => res);
  },
  categoriesList(dicCode, enterpriseId, ruleId) {
    return request
      .get(`/splitRule/layer/categoriesList?dicCode=${dicCode}&enterpriseId=${enterpriseId}&ruleId=${ruleId}`)
      .then((res) => res);
  },
  layerAddList(data) {
    return request.post('/splitRule/layer/addList', data);
  },
  layerDeleteList(data) {
    return request.post('/splitRule/layer/deleteList', data);
  }
};
